import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left: Image */}
            <div className="relative">
              <div className="w-full h-[400px] md:h-[480px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimal%20workspace%20with%20notebook%20and%20clean%20desk%2C%20warm%20cream%20wall%20background%2C%20soft%20natural%20window%20light%2C%20editorial%20photography%2C%20professional%20organization%20concept%2C%20neutral%20beige%20and%20taupe%20palette&width=900&height=700&seq=about-img-v5-unique&orientation=portrait"
                  alt="Mulebuy spreadsheet system overview"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Floating tags */}
              <div className="absolute top-6 left-6 flex items-center gap-2">
                <span className="px-4 py-2 bg-background-50/85 backdrop-blur-sm border border-background-200/50 rounded-full text-xs font-semibold text-foreground-700 whitespace-nowrap">
                  Agent System
                </span>
                <span className="px-4 py-2 bg-background-50/85 backdrop-blur-sm border border-background-200/50 rounded-full text-xs font-semibold text-foreground-700 whitespace-nowrap">
                  2026 Updated
                </span>
                <span className="px-4 py-2 bg-background-50/85 backdrop-blur-sm border border-background-200/50 rounded-full text-xs font-semibold text-foreground-700 whitespace-nowrap">
                  SEO Guide
                </span>
              </div>
            </div>

            {/* Right: Content */}
            <div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4 leading-tight">
                What Is Mulebuy Spreadsheet?
              </h2>

              <div className="flex flex-wrap items-center gap-3 mb-6">
                <span className="px-4 py-1.5 border border-primary-300 text-primary-600 text-xs font-semibold rounded-full whitespace-nowrap">
                  Spreadsheet System
                </span>
                <span className="text-sm text-foreground-500">Agent Shopping</span>
                <span className="text-sm text-foreground-500">Transparent Tracking</span>
              </div>

              {/* Info Card */}
              <div className="bg-foreground-950 rounded-2xl p-6 md:p-8">
                <span className="inline-block px-3 py-1 bg-primary-500/20 text-primary-400 text-xs font-semibold rounded-full mb-4">
                  Key Insight
                </span>
                <p className="text-background-50/90 text-sm md:text-base leading-relaxed mb-4">
                  Mulebuy spreadsheet is a structured shopping system used to organize agent purchases efficiently. Instead of dealing with scattered communication and unclear pricing, the mulebuy spreadsheet system centralizes everything — product listings, pricing breakdowns, order tracking, and shipping updates — all in one transparent, easy-to-navigate format.
                </p>
                <p className="text-background-50/70 text-sm leading-relaxed mb-6">
                  What makes the mulebuy spreadsheet approach unique is its emphasis on transparency. Every fee, every shipping cost, and every product detail is clearly documented in the spreadsheet, eliminating the guesswork that often plagues traditional agent shopping platforms.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link
                    to="/what-is-mulebuy-spreadsheet"
                    className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 text-background-50 text-sm font-bold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer justify-center"
                  >
                    Read Full Guide
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                  <a
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-2 px-5 py-3 border border-background-50/20 text-background-50 text-sm font-bold rounded-full hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer justify-center"
                  >
                    Visit Mulebuy
                    <i className="ri-arrow-right-up-line"></i>
                  </a>
                </div>
              </div>

              {/* Benefits Row */}
              <div className="grid grid-cols-3 gap-4 mt-8">
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-money-dollar-circle-line text-accent-600 text-lg"></i>
                  </div>
                  <p className="text-xs font-semibold text-foreground-700 whitespace-nowrap">Lower Cost</p>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-flashlight-line text-accent-600 text-lg"></i>
                  </div>
                  <p className="text-xs font-semibold text-foreground-700 whitespace-nowrap">Faster Orders</p>
                </div>
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-file-chart-line text-accent-600 text-lg"></i>
                  </div>
                  <p className="text-xs font-semibold text-foreground-700 whitespace-nowrap">Transparent Tracking</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}